import React, { useEffect, useRef, useState } from "react";

interface LineByLineRevealProps {
  lines: React.ReactNode[];
  delayBetween?: number;
  onComplete?: () => void;
}

const LineByLineReveal: React.FC<LineByLineRevealProps> = ({
  lines,
  delayBetween = 300,
  onComplete,
}) => {
  const [visibleCount, setVisibleCount] = useState(0);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    if (lines.length === 0) {
      onCompleteRef.current?.();
      return;
    }
    let index = 0;
    const show = () => {
      index++;
      setVisibleCount(index);
      if (index < lines.length) {
        timer = setTimeout(show, delayBetween);
      } else {
        // 마지막 줄 트랜지션(0.6s) 끝난 후 콜백
        setTimeout(() => onCompleteRef.current?.(), 700);
      }
    };
    let timer = setTimeout(show, delayBetween);
    return () => clearTimeout(timer);
  }, [lines.length, delayBetween]);

  return (
    <div>
      {lines.map((line, i) => (
        <div
          key={i}
          style={{
            opacity: i < visibleCount ? 1 : 0,
            transform: i < visibleCount ? "translateY(0)" : "translateY(14px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
            marginBottom: i < lines.length - 1 ? "1px" : 0,
          }}
        >
          {line}
        </div>
      ))}
    </div>
  );
};

export default LineByLineReveal;
